/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionOssStatsData
 */
export interface SubscriptionOssStatsData {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionOssStatsData
     */
    calendarYear?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionOssStatsData
     */
    currentYearB2cNetAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionOssStatsData
     */
    previousYearB2cNetAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionOssStatsData
     */
    warningAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionOssStatsData
     */
    limitAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionOssStatsData
     */
    currencyCode?: string;
}

/**
 * Check if a given object implements the SubscriptionOssStatsData interface.
 */
export function instanceOfSubscriptionOssStatsData(value: object): value is SubscriptionOssStatsData {
    return true;
}

export function SubscriptionOssStatsDataFromJSON(json: any): SubscriptionOssStatsData {
    return SubscriptionOssStatsDataFromJSONTyped(json, false);
}

export function SubscriptionOssStatsDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionOssStatsData {
    if (json == null) {
        return json;
    }
    return {
        
        'calendarYear': json['calendarYear'] == null ? undefined : json['calendarYear'],
        'currentYearB2cNetAmount': json['currentYearB2cNetAmount'] == null ? undefined : json['currentYearB2cNetAmount'],
        'previousYearB2cNetAmount': json['previousYearB2cNetAmount'] == null ? undefined : json['previousYearB2cNetAmount'],
        'warningAmount': json['warningAmount'] == null ? undefined : json['warningAmount'],
        'limitAmount': json['limitAmount'] == null ? undefined : json['limitAmount'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
    };
}

export function SubscriptionOssStatsDataToJSON(json: any): SubscriptionOssStatsData {
    return SubscriptionOssStatsDataToJSONTyped(json, false);
}

export function SubscriptionOssStatsDataToJSONTyped(value?: SubscriptionOssStatsData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'calendarYear': value['calendarYear'],
        'currentYearB2cNetAmount': value['currentYearB2cNetAmount'],
        'previousYearB2cNetAmount': value['previousYearB2cNetAmount'],
        'warningAmount': value['warningAmount'],
        'limitAmount': value['limitAmount'],
        'currencyCode': value['currencyCode'],
    };
}

